module.exports = __webpack_public_path__ + "static/img/PS-NA2.b9be83c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productConter/params/mini/PS-NA2.png
// module id = pnvS
// module chunks = 1